var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcSmallInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cvl1k0naca",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0097f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00acda"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qfwhpdk1wb",
    x1: 0.5,
    y1: -0.446,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9a9a"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1916"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3276",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0A10 10 0 1 1 0 10 10 10 0 0 1 10 0z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5c-4.687 0-8.5 3.813-8.5 8.5 0 4.687 3.813 8.5 8.5 8.5 4.687 0 8.5-3.813 8.5-8.5 0-4.687-3.813-8.5-8.5-8.5M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0z",
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2962",
    d: "M5618.3 306.633v5.847",
    transform: "translate(-5608.297 -297.033)",
    style: {
      fill: "url(#cvl1k0naca)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2962 - Outline",
    d: "M5618.16 313.707a1.364 1.364 0 0 1-1.364-1.364V306.5a1.364 1.364 0 1 1 2.727 0v5.847a1.363 1.363 0 0 1-1.363 1.36z",
    transform: "translate(-5608.161 -296.897)",
    style: {
      fill: "url(#qfwhpdk1wb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2963",
    d: "M5618.3 306.633v.006",
    transform: "translate(-5608.297 -301.154)",
    style: {
      fill: "url(#cvl1k0naca)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2963 - Outline",
    d: "M5618.16 307.866a1.364 1.364 0 0 1-1.364-1.364v-.002a1.364 1.364 0 1 1 2.727 0v.006a1.363 1.363 0 0 1-1.363 1.36z",
    transform: "translate(-5608.161 -301.018)",
    style: {
      fill: "url(#qfwhpdk1wb)"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSmallInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-smallInfo.f8b176222d491b6cfd4619b5dfafe683.svg";